import {Marker} from "react-map-gl";
import React from "react";

import MarkerImg from "../Icons/marker.svg";
import MarkerImgRecommended from "../Icons/marker-recommended.svg";

import "./MapMarker.scss"
import {useSelector} from "react-redux";
import {getMapObjectsSize} from "../../../store/slices/restaurantSearchSlice";

export const MIN_MARKER_SCALE = 0.4;
export const MAX_MARKER_SCALE = 1;
export const BASE_MARKER_WIDTH = 67.38;
export const BASE_MARKER_HEIGHT = 76.78;

const MapMarker = (props) => {

    const {
        isRecommended,
        onClick
    } = props;

    const mapObjectsSize = useSelector(getMapObjectsSize);

    return  (
        <Marker
            {...props}
            anchor="bottom"
        >
            <img
                width={ mapObjectsSize?.markerWidth || BASE_MARKER_WIDTH }
                height={ mapObjectsSize?.markerHeight || BASE_MARKER_HEIGHT }
                src={ isRecommended ? MarkerImgRecommended : MarkerImg }
                alt=""
                onClick={onClick}
                className="idg-map-marker"
            />
        </Marker>
    )

}

export default MapMarker;
